// Entry point for the build script in your package.json
import '@tailwindplus/elements';

import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

addEventListener("trix-initialize", function (e) {
  const file_tools = document.querySelector(".trix-button-group--file-tools");
  file_tools.remove();
})
addEventListener("trix-file-accept", function (e) {
  e.preventDefault();
})
